import React, { useState, useEffect } from 'react';
import { Add } from '@material-ui/icons';
import AddParam from './Modals/AddParam';
import EditParam from './Modals/EditParam';
import DeleteParam from './Modals/DeleteParam';
import notice from 'src/common/components/Notice';
import FullTable from 'src/common/components/FullTable';
import PageLayout from 'src/common/components/PageLayout';
import { parameterAPI } from 'src/api/modules/parameters';
import CustomButton from 'src/common/components/CustomButton';
import { columns, defaultFilter, filterForm, editForm } from './utils/list_data';

const Parameters = () => {
	const [idParam, setIdParam] = useState([]);
	const [keyParams, setParamsKey] = useState([]);
	const [parameters, setParameters] = useState([]);
	const [editModal, setEditModal] = useState(false);
	const [valueParams, setParamsValue] = useState([]);
	const [filter, setFilter] = useState(defaultFilter);
	const [deleteModal, setDeleteModal] = useState(false);
	const [addParamModal, setAddParamModal] = useState(false);

	useEffect(() => {
		getAllParameters();
	}, []);

	useEffect(() => {
		getParameters();
	}, []);

	const getAllParameters = () => {
		let filterKey = [];
		let filterValue = [];
		parameterAPI
			.getParameters()
			.then((response) => {
				if (response.parametros && response.parametros.length > 0) {
					response.parametros.forEach((item) => {
						filterKey.push({
							value: item.id,
							text: item.clave,
						});

						filterValue.push({
							value: item.id,
							text: item.valor,
						});
					});

					setParamsKey(filterKey);
					setParamsValue(filterValue);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const getParameters = () => {
		parameterAPI
			.getParameters()
			.then((response) => {
				if (response.parametros && response.parametros.length > 0) {
					setParameters(response.parametros);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const onStatus = (dataRow) => {
		parameterAPI
			.getParameterDisable(dataRow.id, dataRow.estatus === 'A' ? 'I' : 'A')
			.then(() => {
				notice(
					`El parámetro se ${
						dataRow.estatus === 'I' ? 'activo' : 'inactivo'
					} correctamente.`,
					'success'
				);
			})
			.catch(() => {
				notice(
					`Ocurrio un error al ${
						dataRow.estatus === 'I' ? 'acctivar' : 'desactivar'
					} el parámetro.`
				);
			});

		getParameters();
	};

	const onCloseModalAdd = () => {
		setIdParam(editForm);
		setAddParamModal(false);
	};

	const onCloseModalEdit = () => {
		setIdParam(editForm);
		setEditModal(false);
	};

	const onSuccess = (msg, type_msg, type) => {
		notice(msg, type_msg);
		switch (type) {
			case 1:
				onCloseModalAdd();
				break;
			case 2:
				onCloseModalEdit();
				break;
			case 3:
				setDeleteModal(false);
				break;
			default:
				break;
		}
		getParameters();
	};

	const onConfirmFilter = () => {
		parameterAPI
			.getParameterByFilters(
				filter.clave?.text,
				filter.valor?.text,
				filter.descripcion,
				filter.estatus
			)
			.then((response) => {
				setParameters(response.parametros);
			})
			.catch(() => {
				notice('Ha ocurrido un error con la busqueda');
			});
	};

	const onNewParam = () => {
		setAddParamModal(true);
	};

	const onEditParam = (dataRow) => {
		setIdParam(dataRow);
		setEditModal(true);
	};

	const onDelete = (dataRow) => {
		setIdParam(dataRow);
		setDeleteModal(true);
	};

	const onClear = () => {
		setFilter(defaultFilter);
		getParameters();
	};

	const handleChangeFilter = ({ target }) => {
		const { name, value } = target;
		setFilter({ ...filter, [name]: value });
	};

	const onChangeData = ({ target }) => {
		setIdParam({ ...idParam, [target.name]: target.value });
	};

	return (
		<PageLayout>
			<CustomButton
				mainText="Nuevo Parámetro"
				color="primary"
				className="m-3"
				icon={Add}
				style={{
					position: 'absolute',
					right: 35,
				}}
				onClick={() => {
					onNewParam();
				}}
			/>
			<FullTable
				title="Parámetros del Sistema"
				items={parameters}
				columns={columns(onDelete, onEditParam, onStatus)}
				filter={filter}
				filterForm={filterForm(onConfirmFilter, onClear, keyParams, valueParams)}
				onFilterChange={handleChangeFilter}
				showPagination
				useBackendPagination={false}
			/>
			<AddParam
				open={addParamModal}
				parent={idParam}
				onClose={onCloseModalAdd}
				onSuccess={onSuccess}
				onChangeData={onChangeData}
			/>
			<DeleteParam
				open={deleteModal}
				onSuccess={onSuccess}
				onDelete={onDelete}
				parameter={idParam}
				onClose={() => {
					setDeleteModal(false);
				}}
			/>
			<EditParam
				open={editModal}
				onClose={onCloseModalEdit}
				onSuccess={onSuccess}
				onEditParam={onEditParam}
				parameter={idParam}
				onChangeData={onChangeData}
			/>
		</PageLayout>
	);
};

export default Parameters;
